import ReactGA from 'react-ga'

export const initGA = () => {
  if (!window.GA_INTIALIZED) {
    ReactGA.initialize('UA-149089998-9');
    ReactGA.pageview(window.location.pathname + window.location.search);
    window.GA_INTIALIZED = true
  }
}
